import { Fragment } from 'react/jsx-runtime';
import { LaunchDetachedButton } from '@/features/LoadingScreen/LaunchDetachedButton';
import { AddFundsWrapper } from '@/features/Wrappers/AddFundsWrapper';
import SoundToggle from '@/features/GameWindow/SoundToggle';

import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/store/useStore';

export const GameWindowControlsHeader: React.FC = () => {
  const { showExitButton, showSoundButton } = useStore(
    useShallow((s) => s.commonUIContext),
  );

  const verticalLine =
    showExitButton && showSoundButton ? (
      <div className="vertical-divider" />
    ) : (
      <Fragment />
    );

  return (
    <>
      <LaunchDetachedButton />
      <AddFundsWrapper showBalance={true} size={28} label="Deposit" />
      {showSoundButton && <SoundToggle />}
      {verticalLine}
    </>
  );
};
